import { action } from 'satcheljs';
export var loadFullBody = action('loadFullBody', function (viewState) {
    return { viewState: viewState };
});
//# sourceMappingURL=loadFullBody.js.map